/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_ImportInputs */



/**
* | output |
* | --- |
* | "Confirm Import" |
*
* @param {Confirm_ImportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const confirm_import = /** @type {((inputs?: Confirm_ImportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_ImportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Confirmer l'importation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Import bestätigen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Conferma importazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подтвердить импорт")
	if (locale === "es") return /** @type {LocalizedString} */ ("Confirmar importación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("确认进口")
	if (locale === "ja") return /** @type {LocalizedString} */ ("インポートの確認")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आयात की पुष्टि करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Confirmar importação")
	return /** @type {LocalizedString} */ ("Confirm Import")
});